import React, { useState } from 'react';
import SecondPasswordDialog from '../SecondPasswordDialog/SecondPasswordDialog';

interface HiddenPageProps {
  component: JSX.Element;
}

const HiddenPage: React.FC<HiddenPageProps> = ({ component }) => {
  const [passed, setPassed] = useState(false);

  if (!passed) {
    return <SecondPasswordDialog open onSuccess={() => setPassed(true)} />;
  }

  return component;
};

export default HiddenPage;
